var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendarAlt = function SvgCalendarAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2857 5.25H16.5714V3.42188C16.5714 3.18984 16.3786 3 16.1429 3H14.7143C14.4786 3 14.2857 3.18984 14.2857 3.42188V5.25H9.71429V3.42188C9.71429 3.18984 9.52143 3 9.28571 3H7.85714C7.62143 3 7.42857 3.18984 7.42857 3.42188V5.25H5.71429C4.76786 5.25 4 6.00586 4 6.9375V19.3125C4 20.2441 4.76786 21 5.71429 21H18.2857C19.2321 21 20 20.2441 20 19.3125V6.9375C20 6.00586 19.2321 5.25 18.2857 5.25ZM18.0714 19.3125H5.92857C5.81071 19.3125 5.71429 19.2176 5.71429 19.1016V8.625H18.2857V19.1016C18.2857 19.2176 18.1893 19.3125 18.0714 19.3125Z",
    fill: "#555555"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-alt.cd9b5cfc.svg";
export { ForwardRef as ReactComponent };